"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function FileSize(_a) {
    var _b;
    var bytes = _a.bytes, _c = _a.decimals, decimals = _c === void 0 ? 0 : _c, forceUnit = _a.forceUnit;
    if (forceUnit === undefined)
        return jsx_runtime_1.jsx("span", { children: formatBytes(bytes, decimals) }, void 0);
    var _d = ((_b = Object.entries(UnitMap).find(function (_a) {
        var key = _a[0];
        return key === forceUnit;
    })) === null || _b === void 0 ? void 0 : _b[1]) || UnitMap.byte, factor = _d.factor, label = _d.label;
    var size = bytes / factor;
    return jsx_runtime_1.jsx("span", { children: numberFormat(size, decimals) + " " + label }, void 0);
}
exports.default = FileSize;
var numberFormat = function (n, decimals) {
    if (decimals === void 0) { decimals = 0; }
    return Intl.NumberFormat(undefined, { maximumFractionDigits: decimals }).format(n);
};
var FileSizeUnit;
(function (FileSizeUnit) {
    FileSizeUnit["byte"] = "byte";
    FileSizeUnit["kilobyte"] = "kilobyte";
    FileSizeUnit["megabyte"] = "megabyte";
    FileSizeUnit["gigabyte"] = "gigabyte";
    FileSizeUnit["terabyte"] = "terabyte";
    FileSizeUnit["petabyte"] = "petabyte";
    FileSizeUnit["exabyte"] = "exabyte";
    FileSizeUnit["zetabyte"] = "zetabyte";
    FileSizeUnit["yottabyte"] = "yottabyte";
})(FileSizeUnit || (FileSizeUnit = {}));
var UnitMap = (_a = {},
    _a[FileSizeUnit.byte] = {
        label: 'Bytes',
        factor: 1,
    },
    _a[FileSizeUnit.kilobyte] = {
        label: 'KB',
        factor: 1024,
    },
    _a[FileSizeUnit.megabyte] = {
        label: 'MB',
        factor: Math.pow(1024, 2),
    },
    _a[FileSizeUnit.gigabyte] = {
        label: 'GB',
        factor: Math.pow(1024, 3),
    },
    _a[FileSizeUnit.terabyte] = {
        label: 'TB',
        factor: Math.pow(1024, 4),
    },
    _a[FileSizeUnit.petabyte] = {
        label: 'PB',
        factor: Math.pow(1024, 5),
    },
    _a[FileSizeUnit.exabyte] = {
        label: 'EB',
        factor: Math.pow(1024, 6),
    },
    _a[FileSizeUnit.zetabyte] = {
        label: 'ZB',
        factor: Math.pow(1024, 7),
    },
    _a[FileSizeUnit.yottabyte] = {
        label: 'YB',
        factor: Math.pow(1024, 8),
    },
    _a);
var formatBytes = function (bytes, decimals) {
    if (bytes === 0)
        return "0 " + UnitMap.byte.label;
    var k = 1024;
    var dm = Math.max(decimals, 0);
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    var size = bytes / Math.pow(k, i);
    var unit = Object.values(UnitMap)[i].label;
    return numberFormat(size, dm) + " " + unit;
};
//# sourceMappingURL=FileSize.js.map